(function() {
  var __sections__ = {};
  (function() {
    for(var i = 0, s = document.getElementById('sections-script').getAttribute('data-sections').split(','); i < s.length; i++)
      __sections__[s[i]] = true;
    })();
    (function() {
  if (!__sections__["main-blog"]) return;
  try {
    
window.onload = () => {
  const checkboxes = document.querySelectorAll('.checkbox')
  let searchParams = new URLSearchParams(window.location.search)
  let filters = searchParams.get('filter')?.split(',')
  checkboxes.forEach(element => {
    if (filters?.includes(element.name)) element.checked = true
    else element.checked = false
    element.addEventListener('change', function (e) {
      if (e.currentTarget.checked) {
        if (!filters) filters = []
        filters.push(e.currentTarget.name)
      } else {
        const index = filters.indexOf(e.currentTarget.name)
        if (index !== -1) filters.splice(index, 1)
      }
      if (filters.length === 0) {
        window.location.href = `${window.location.pathname}`
        return false
      } else searchParams.set('filter', filters.join(','))
      window.location.href = `${window.location.pathname}?filter=${filters.join(',').toString()}`
    })
  })
}

  } catch(e) { console.error(e); }
})();
})();
